import { c as _c } from "react/compiler-runtime";
// Полноэкранный выбор «Способ доставки» (кадры 3926:20709, 3926:20905,
// 3926:21698): шапка 49 «‹ Назад» с линией снизу, слева колонка 320 (отступы
// 20/20/20/30, промежутки 20) — заголовок 20/23 w600, вкладки «Самовывоз /
// Доставка курьером» 16/20 w600, поиск адреса и список пунктов выдачи либо
// форма курьерского адреса с «Привезти сюда»; справа карта (Leaflet + OSM)
// с выносками пунктов «{перевозчик} · цена, срок». Нажатие на выноску
// раскрывает её: адрес, режим работы и кнопка «Привезти сюда».
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { useEffect, useRef, useState } from "react";
import { api, type CitySuggestion, type PickupPoint } from "@/api";
import { ChevronLeftIcon, MarkerPinIcon, MinusIcon, PlusIcon } from "@/components/icons";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { CourierAddressFields, type CourierAddressValues } from "./address-modals";
import { carrierTitle } from "./pickup-modals";
import { ModalField, Radio } from "./ui";
export type PickerTab = "pickup" | "courier";
export function DeliveryPicker(t0) {
  const $ = _c(52);
  const {
    open,
    onClose,
    tab,
    onTabChange,
    courierAvailable,
    pickupAvailable,
    city,
    onCityPick,
    points,
    pointsLoading,
    selectedCode,
    onPickPoint,
    carrier,
    pickupPriceLabel,
    courier,
    onCourierChange,
    onCourierSubmit,
    courierBusy,
    pvzRequired: t1,
    onChoosePickup
  } = t0;
  const pvzRequired = t1 === undefined ? true : t1;
  let t2;
  let t3;
  if ($[0] !== onClose || $[1] !== open) {
    t2 = () => {
      if (!open) {
        return;
      }
      const prev = document.body.style.overflow;
      document.body.style.overflow = "hidden";
      const onKey = e => e.key === "Escape" && onClose();
      window.addEventListener("keydown", onKey);
      return () => {
        document.body.style.overflow = prev;
        window.removeEventListener("keydown", onKey);
      };
    };
    t3 = [open, onClose];
    $[0] = onClose;
    $[1] = open;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  useEffect(t2, t3);
  if (!open) {
    return null;
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <ChevronLeftIcon size={24} />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== onClose) {
    t5 = <header className="flex h-[49px] shrink-0 items-center border-b border-black/10 px-4 md:px-[30px]"><button type="button" onClick={onClose} className="flex items-center gap-1.5 rounded-[8px] text-[14px] leading-[18px] font-semibold text-[#1F1F1F] outline-none focus-visible:ring-2 focus-visible:ring-osmix-tangelo/40">{t4}Назад</button></header>;
    $[5] = onClose;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <h2 className="text-[20px] leading-[23px] font-semibold tracking-[-0.31px] text-[#161616]">Способ доставки</h2>;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== pickupAvailable) {
    t7 = ["pickup", "\u0421\u0430\u043C\u043E\u0432\u044B\u0432\u043E\u0437", pickupAvailable];
    $[8] = pickupAvailable;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== courierAvailable) {
    t8 = ["courier", "\u0414\u043E\u0441\u0442\u0430\u0432\u043A\u0430 \u043A\u0443\u0440\u044C\u0435\u0440\u043E\u043C", courierAvailable];
    $[10] = courierAvailable;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t7 || $[13] !== t8) {
    t9 = [t7, t8];
    $[12] = t7;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  const t10 = t9 as const;
  let t11;
  if ($[15] !== onTabChange || $[16] !== t10 || $[17] !== tab) {
    t11 = <div className="mt-5 flex gap-6 border-b border-[#1F1F1F]/8" role="tablist">{t10.map(t12 => {
        const [key, label, enabled] = t12;
        return <button key={key} type="button" role="tab" aria-selected={tab === key} disabled={!enabled} onClick={() => onTabChange(key)} className={cn("-mb-px border-b pt-1.5 pb-2.5 text-[16px] leading-5 font-semibold tracking-[-0.31px] whitespace-nowrap outline-none transition-colors focus-visible:ring-2 focus-visible:ring-osmix-tangelo/40 disabled:opacity-40", tab === key ? "border-[#1F1F1F] text-[#1F1F1F]" : "border-transparent text-[#1F1F1F]/48 hover:text-[#1F1F1F]")}>{label}</button>;
      })}</div>;
    $[15] = onTabChange;
    $[16] = t10;
    $[17] = tab;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== carrier || $[20] !== city || $[21] !== courier || $[22] !== courierBusy || $[23] !== onChoosePickup || $[24] !== onCityPick || $[25] !== onCourierChange || $[26] !== onCourierSubmit || $[27] !== onPickPoint || $[28] !== points || $[29] !== pointsLoading || $[30] !== pvzRequired || $[31] !== selectedCode || $[32] !== tab) {
    t12 = tab === "pickup" ? <div className="mt-5 flex flex-col"><CitySearch city={city} onPick={onCityPick} /><div className="mt-5 flex flex-col gap-3">{!pvzRequired ? <><p className="text-[14px] leading-5 text-[#1F1F1F]/64">Для этого заказа самовывоз оформляется без выбора пункта выдачи.</p><Button block={true} onClick={onChoosePickup} className="mt-2">Выбрать самовывоз</Button></> : pointsLoading ? <p className="text-[14px] text-[#1F1F1F]/48">Загружаем пункты выдачи…</p> : points.length === 0 ? <p className="text-[14px] text-[#1F1F1F]/48">{city ? "\u0412 \u044D\u0442\u043E\u043C \u0433\u043E\u0440\u043E\u0434\u0435 \u043D\u0435\u0442 \u043F\u0443\u043D\u043A\u0442\u043E\u0432 \u0432\u044B\u0434\u0430\u0447\u0438 \u043F\u0435\u0440\u0435\u0432\u043E\u0437\u0447\u0438\u043A\u0430" : "\u0423\u043A\u0430\u0436\u0438\u0442\u0435 \u0433\u043E\u0440\u043E\u0434, \u0447\u0442\u043E\u0431\u044B \u0443\u0432\u0438\u0434\u0435\u0442\u044C \u043F\u0443\u043D\u043A\u0442\u044B \u0432\u044B\u0434\u0430\u0447\u0438"}</p> : points.map(p => <button key={p.code} type="button" onClick={() => onPickPoint(p)} data-testid="picker-point" className="flex items-start gap-2 rounded-[4px] text-left text-[14px] leading-[18px] font-medium text-[#1F1F1F] outline-none focus-visible:ring-2 focus-visible:ring-osmix-tangelo/40"><span className="pt-px"><Radio checked={p.code === selectedCode} small={true} /></span><span className="min-w-0">{carrierTitle(carrier)}{p.type === "POSTAMAT" ? ", \u043F\u043E\u0441\u0442\u0430\u043C\u0430\u0442" : ""}, {p.address}{p.isDressingRoom && <span className="block text-[12px] text-[#32D47D]">есть примерочная</span>}</span></button>)}</div></div> : <div className="mt-5 flex flex-col"><CourierAddressFields value={courier} onChange={onCourierChange} compact={true} /><Button block={true} onClick={onCourierSubmit} disabled={courierBusy} data-testid="courier-submit" className="mt-5">Привезти сюда</Button></div>;
    $[19] = carrier;
    $[20] = city;
    $[21] = courier;
    $[22] = courierBusy;
    $[23] = onChoosePickup;
    $[24] = onCityPick;
    $[25] = onCourierChange;
    $[26] = onCourierSubmit;
    $[27] = onPickPoint;
    $[28] = points;
    $[29] = pointsLoading;
    $[30] = pvzRequired;
    $[31] = selectedCode;
    $[32] = tab;
    $[33] = t12;
  } else {
    t12 = $[33];
  }
  let t13;
  if ($[34] !== t11 || $[35] !== t12) {
    t13 = <aside className="flex w-full shrink-0 flex-col overflow-y-auto px-4 py-5 md:w-[320px] md:pr-5 md:pl-[30px]">{t6}{t11}{t12}</aside>;
    $[34] = t11;
    $[35] = t12;
    $[36] = t13;
  } else {
    t13 = $[36];
  }
  let t14;
  if ($[37] !== points || $[38] !== tab) {
    t14 = tab === "pickup" ? points : [];
    $[37] = points;
    $[38] = tab;
    $[39] = t14;
  } else {
    t14 = $[39];
  }
  let t15;
  if ($[40] !== carrier || $[41] !== onPickPoint || $[42] !== pickupPriceLabel || $[43] !== selectedCode || $[44] !== t14) {
    t15 = <div className="relative min-h-[320px] flex-1"><PickerMap points={t14} selectedCode={selectedCode} carrier={carrier} priceLabel={pickupPriceLabel} onPick={onPickPoint} /></div>;
    $[40] = carrier;
    $[41] = onPickPoint;
    $[42] = pickupPriceLabel;
    $[43] = selectedCode;
    $[44] = t14;
    $[45] = t15;
  } else {
    t15 = $[45];
  }
  let t16;
  if ($[46] !== t13 || $[47] !== t15) {
    t16 = <div className="flex min-h-0 flex-1 flex-col md:flex-row">{t13}{t15}</div>;
    $[46] = t13;
    $[47] = t15;
    $[48] = t16;
  } else {
    t16 = $[48];
  }
  let t17;
  if ($[49] !== t16 || $[50] !== t5) {
    t17 = <div className="fixed inset-0 z-50 flex flex-col bg-white" role="dialog" aria-modal="true" aria-label={"\u0421\u043F\u043E\u0441\u043E\u0431 \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0438"} data-testid="delivery-picker">{t5}{t16}</div>;
    $[49] = t16;
    $[50] = t5;
    $[51] = t17;
  } else {
    t17 = $[51];
  }
  return t17;
}
function CitySearch(t0) {
  const $ = _c(25);
  const {
    city,
    onPick
  } = t0;
  const [q, setQ] = useState(city);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [items, setItems] = useState(t1);
  const [open, setOpen] = useState(false);
  let t2;
  let t3;
  if ($[1] !== city) {
    t2 = () => setQ(city);
    t3 = [city];
    $[1] = city;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  useEffect(t2, t3);
  let t4;
  let t5;
  if ($[4] !== open || $[5] !== q) {
    t4 = () => {
      const query = q.trim();
      if (!open || query.length < 2) {
        setItems([]);
        return;
      }
      const t = setTimeout(() => {
        api.geo.citySuggest(query).then(r => setItems(r.slice(0, 6))).catch(() => setItems([]));
      }, 250);
      return () => clearTimeout(t);
    };
    t5 = [q, open];
    $[4] = open;
    $[5] = q;
    $[6] = t4;
    $[7] = t5;
  } else {
    t4 = $[6];
    t5 = $[7];
  }
  useEffect(t4, t5);
  let t6;
  if ($[8] !== city || $[9] !== onPick || $[10] !== q) {
    t6 = () => {
      const query_0 = q.trim();
      if (query_0 && query_0 !== city) {
        onPick({
          city: query_0
        });
      }
    };
    $[8] = city;
    $[9] = onPick;
    $[10] = q;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const commit = t6;
  let t7;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = v => {
      setOpen(true);
      setQ(v);
    };
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== commit) {
    t8 = () => setTimeout(() => {
      setOpen(false);
      commit();
    }, 150);
    $[13] = commit;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== q || $[16] !== t8) {
    t9 = <ModalField label={"\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0430\u0434\u0440\u0435\u0441 \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0438"} placeholder={"\u0410\u0434\u0440\u0435\u0441"} value={q} testId="picker-city" onChange={t7} onBlur={t8} />;
    $[15] = q;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== items || $[19] !== onPick || $[20] !== open) {
    t10 = open && items.length > 0 && <ul className="absolute top-full right-0 left-0 z-10 mt-1 max-h-60 overflow-auto rounded-[10px] bg-white p-1 shadow-[0_4px_24px_rgba(0,0,0,0.12)]">{items.map(c => <li key={c.value}><button type="button" onMouseDown={_temp} onClick={() => {
          setOpen(false);
          setQ(c.city);
          onPick({
            city: c.city,
            country: c.country,
            postalCode: c.postalCode,
            region: c.region || undefined
          });
        }} className="w-full rounded-[8px] px-3 py-2.5 text-left text-[14px] text-[#1F1F1F] hover:bg-[#F8F8F8]">{c.value}</button></li>)}</ul>;
    $[18] = items;
    $[19] = onPick;
    $[20] = open;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t10 || $[23] !== t9) {
    t11 = <div className="relative">{t9}{t10}</div>;
    $[22] = t10;
    $[23] = t9;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  return t11;
}

// Выноска пункта на карте (кадры 3926:20709 / 3926:20905): белая карточка
// r10 с иконкой-коробкой, названием перевозчика 14/18 w600 и строкой «цена,
// срок» 12/16. Раскрытая (по нажатию) — на #FFF5F2 с обводкой #FA5C2E: ещё
// адрес, режим работы и тёмная кнопка «Привезти сюда» 12/16 w600.
function _temp(e) {
  return e.preventDefault();
}
const esc = (v: string): string => v.replace(/[&<>"']/g, c => ({
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;"
})[c] ?? c);
const BOX_ICON = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#6982BA" stroke-width="1.6" stroke-linejoin="round" style="flex:none"><path d="M12 3 20 7.5v9L12 21l-8-4.5v-9L12 3Z"/><path d="m4 7.5 8 4.5 8-4.5M12 12v9"/></svg>`;
const calloutHtml = (title: string, sub: string, selected: boolean, expanded: {
  address: string;
  workTime?: string;
} | null): string => {
  const box = `transform:translate(-50%,-100%);display:inline-flex;gap:8px;align-items:flex-start;padding:8px 12px;border-radius:10px;box-shadow:0 2px 12px rgba(0,0,0,.14);white-space:nowrap;font:600 14px/18px Manrope,system-ui,sans-serif;color:#000;cursor:pointer;`;
  if (!expanded) {
    return `<div style="${box}background:#fff;${selected ? "outline:1.5px solid #FA5C2E;" : ""}">${BOX_ICON}` + `<span><span style="display:block">${esc(title)}</span>${sub ? `<span style="display:block;font-weight:400;font-size:12px;line-height:16px;color:#1F1F1F">${esc(sub)}</span>` : ""}</span></div>`;
  }
  const line = (v: string) => `<span style="display:block;font-weight:400;font-size:12px;line-height:16px;color:#1F1F1F;white-space:normal">${esc(v)}</span>`;
  return `<div style="${box}flex-direction:column;gap:2px;max-width:220px;background:#FFF5F2;outline:1px solid #FA5C2E;">` + `<span style="display:flex;width:100%;justify-content:space-between;gap:16px"><span>${esc(title)}</span>${BOX_ICON.replace("#6982BA", "#FA5C2E")}</span>` + (sub ? line(sub) : "") + line(expanded.address) + (expanded.workTime ? line(expanded.workTime) : "") + `<button type="button" data-pick="1" style="margin-top:8px;height:32px;padding:0 12px;border:0;border-radius:10px;background:#1F1F1F;color:#fff;font:600 12px/16px Manrope,system-ui,sans-serif;cursor:pointer">Привезти сюда</button>` + `</div>`;
};
function PickerMap({
  points,
  selectedCode,
  carrier,
  priceLabel,
  onPick
}: {
  points: PickupPoint[];
  selectedCode?: string;
  carrier: string;
  priceLabel?: string;
  onPick: (p: PickupPoint) => void;
}) {
  const elRef = useRef<HTMLDivElement | null>(null);
  const mapRef = useRef<L.Map | null>(null);
  const layerRef = useRef<L.LayerGroup | null>(null);
  const meRef = useRef<L.Marker | null>(null);
  const onPickRef = useRef(onPick);
  onPickRef.current = onPick;
  // Раскрытая выноска: пункт, на который нажали на карте.
  const [openCode, setOpenCode] = useState<string | null>(null);
  useEffect(() => {
    if (!elRef.current) return;
    const map = L.map(elRef.current, {
      zoomControl: false,
      attributionControl: false
    }).setView([55.7558, 37.6173], 11);
    L.tileLayer("https://tile.openstreetmap.org/{z}/{x}/{y}.png", {
      maxZoom: 19
    }).addTo(map);
    layerRef.current = L.layerGroup().addTo(map);
    mapRef.current = map;
    map.on("click", () => setOpenCode(null));
    setTimeout(() => map.invalidateSize(), 0);
    return () => {
      map.remove();
      mapRef.current = null;
    };
  }, []);

  // Новый список пунктов (другой город) — раскрытую выноску закрываем.
  // biome-ignore lint/correctness/useExhaustiveDependencies: сброс при смене списка
  useEffect(() => setOpenCode(null), [points]);
  useEffect(() => {
    const map_0 = mapRef.current;
    if (!map_0 || points.length === 0) return;
    map_0.fitBounds(L.latLngBounds(points.map(p => [p.latitude, p.longitude] as [number, number])), {
      padding: [80, 80],
      maxZoom: 14
    });
  }, [points]);
  useEffect(() => {
    const map_1 = mapRef.current;
    const layer = layerRef.current;
    if (!map_1 || !layer) return;
    layer.clearLayers();
    for (const p_0 of points) {
      const expanded = p_0.code === openCode ? {
        address: p_0.address,
        workTime: p_0.workTime
      } : null;
      const icon = L.divIcon({
        className: "",
        html: calloutHtml(carrierTitle(carrier), priceLabel ?? "", p_0.code === selectedCode, expanded),
        iconSize: [0, 0]
      });
      L.marker([p_0.latitude, p_0.longitude], {
        icon,
        title: p_0.address,
        zIndexOffset: expanded ? 1000 : 0
      }).on("click", (e: L.LeafletMouseEvent) => {
        L.DomEvent.stopPropagation(e);
        const target = e.originalEvent?.target as HTMLElement | null;
        if (target?.closest("[data-pick]")) onPickRef.current(p_0);else setOpenCode(p_0.code);
      }).addTo(layer);
    }
  }, [points, selectedCode, carrier, priceLabel, openCode]);
  const locate = () => {
    const map_2 = mapRef.current;
    if (!map_2 || !navigator.geolocation) return;
    navigator.geolocation.getCurrentPosition(pos => {
      const ll: [number, number] = [pos.coords.latitude, pos.coords.longitude];
      // «Вы здесь»: #FA5C2E r12, отступы 6/8, 14/18 w600 белым (кадр 3926:21698).
      const icon_0 = L.divIcon({
        className: "",
        iconSize: [0, 0],
        html: `<div style="transform:translate(-50%,-100%);display:inline-flex;align-items:center;gap:4px;padding:6px 8px;background:#FA5C2E;color:#fff;border-radius:12px;font:600 14px/18px Manrope,system-ui,sans-serif;white-space:nowrap">Вы здесь</div>`
      });
      meRef.current?.remove();
      meRef.current = L.marker(ll, {
        icon: icon_0
      }).addTo(map_2);
      map_2.setView(ll, 14);
    });
  };
  return <>
			<div ref={elRef} className="absolute inset-0" />
			{/* Инструменты карты: белая пилюля 48 r100, отступ 6, кнопки 48 через 8 */}
			<div className="absolute right-4 bottom-4 z-[500] flex w-12 flex-col gap-2 rounded-full bg-white py-1.5 shadow-[0_2px_12px_rgba(0,0,0,0.12)] md:right-[30px] md:bottom-[30px]">
				<MapButton label="Приблизить" onClick={() => mapRef.current?.zoomIn()}>
					<PlusIcon size={24} />
				</MapButton>
				<MapButton label="Отдалить" onClick={() => mapRef.current?.zoomOut()}>
					<MinusIcon size={24} />
				</MapButton>
				<MapButton label="Моё местоположение" onClick={locate}>
					<MarkerPinIcon size={24} />
				</MapButton>
			</div>
		</>;
}
function MapButton(t0) {
  const $ = _c(4);
  const {
    label,
    onClick,
    children
  } = t0;
  let t1;
  if ($[0] !== children || $[1] !== label || $[2] !== onClick) {
    t1 = <button type="button" aria-label={label} onClick={onClick} className="grid size-12 place-items-center rounded-full text-[#1F1F1F] outline-none hover:bg-[#F8F8F8] focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-osmix-tangelo/40">{children}</button>;
    $[0] = children;
    $[1] = label;
    $[2] = onClick;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}